import { EditOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

import styles from "./styles.module.css";

/**
 * مدادِ داخلِ فیلدهای «ایمیل» و «شماره همراه».
 *
 * خودِ فیلد `disabled` نیست و `readOnly` است: خاکستری‌شدن یعنی «اینجا کاری از
 * دستت برنمی‌آید»، در حالی که این دو کاملاً قابل تغییرند — فقط راهش تایپ کردن
 * نیست، چون هر تغییری کد تأیید می‌خواهد. مداد همان راه است.
 */
const ContactEditIcon = ({ label, onEdit }) => (
  <Tooltip title={`تغییر ${label}`}>
    <span
      className={styles.icon}
      role="button"
      tabIndex={0}
      aria-label={`تغییر ${label}`}
      onClick={onEdit}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onEdit?.();
        }
      }}
    >
      <EditOutlined />
    </span>
  </Tooltip>
);

export default ContactEditIcon;
